var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { windowExist } from 'src/shared/constants';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './modal.module.scss';
import { IDENTIFIER_MODAL, IDENTIFIER_MODAL_CONTAINER, IDENTIFIER_MODAL_SUBTITLE, IDENTIFIER_MODAL_TITLE, } from 'src/ui/components/modal/constants';
export var Modal = function (props) {
    var _a;
    var title = props.title, subtitle = props.subtitle, color = props.color, children = props.children, onClose = props.onClose, className = props.className;
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var _c = useState(false), isMouseClickActive = _c[0], setIsMouseClickActive = _c[1];
    var cardRef = useRef(null);
    var timeout = null;
    var handleClose = function (e) {
        if (!isMouseClickActive) {
            setIsVisible(false);
            timeout = setTimeout(function () { return onClose(); }, 300);
        }
    };
    useMount(function () {
        setIsVisible(true);
        return clearTimeout(timeout);
    });
    useEffect(function () {
        if (isVisible) {
            var mouseClickTimeout_1 = null;
            var handleMouseClickDown_1 = function () { return (mouseClickTimeout_1 = setTimeout(function () { return setIsMouseClickActive(true); }, 200)); };
            var handleMouseClickUp_1 = function () { return (mouseClickTimeout_1 = setTimeout(function () { return setIsMouseClickActive(false); }, 200)); };
            document.addEventListener('mousedown', handleMouseClickDown_1);
            document.addEventListener('mouseup', handleMouseClickUp_1);
            return function () {
                clearTimeout(mouseClickTimeout_1);
                document.removeEventListener('mousedown', handleMouseClickDown_1);
                document.removeEventListener('mouseup', handleMouseClickUp_1);
            };
        }
    }, [cardRef, isVisible, isMouseClickActive]);
    var modalDomIdPortal = windowExist ? document.getElementById('modal') : null;
    var modalClassNames = classNames(styles.modalWrapper, (_a = {}, _a[styles.modalWrapperOpen] = isVisible, _a));
    var modalContainerClassNames = classNames(styles.modalContainer, className);
    return createPortal(_jsx("div", __assign({ "data-test": IDENTIFIER_MODAL, className: modalClassNames, onClick: handleClose }, { children: _jsxs("div", __assign({ ref: cardRef, className: styles.modalCard, onClick: function (e) { return e.stopPropagation(); } }, { children: [_jsxs("div", __assign({ className: styles.headlineModal }, { children: [_jsxs("div", __assign({ className: styles.modalTitleWrapper }, { children: [_jsx("h2", __assign({ "data-test": IDENTIFIER_MODAL_TITLE, className: styles.title, style: { color: color } }, { children: title })), _jsx("p", __assign({ "data-test": IDENTIFIER_MODAL_SUBTITLE, className: styles.subtitle }, { children: subtitle }))] })), _jsx(Icons, { icon: E_ICONS.CLOSE, className: styles.closeIcon, onClick: handleClose })] })), _jsx("span", { className: styles.separator, style: { backgroundColor: color } }), _jsx("div", __assign({ "data-test": IDENTIFIER_MODAL_CONTAINER, className: modalContainerClassNames }, { children: children }))] })) })), modalDomIdPortal);
};
